var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specialTopic"},[_c('HeadBar',{attrs:{"titleName":"专题列表"}}),_c('div',{staticClass:"content oepnX"},[_c('SpecialTopicList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }